import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { useSetCredentials } from '../components/CredentialsProvider'
import { useSecurityConfig } from '../components/SecurityConfigProvider'
import { emptyCredential } from '../helpers/credentials'

/* A React hook that provides a function to logout from the application.
 */
export const useLogout = () => {
  const securityConfig = useSecurityConfig()
  const setCredentials = useSetCredentials()
  const history = useHistory()

  const logout = useCallback(() => {
    setCredentials(null, 'local')
    setCredentials(null, 'session')

    history.push(securityConfig.loginPath)
  }, [setCredentials])

  return logout
}
